var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showInstallBanner)?_c('li',{staticClass:"nav-link A2HSInstallPrompt"},[_c('a',{staticClass:"nav-item dropdown-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.install.apply(null, arguments)}}},[_vm._v("Установить Reactor")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }